import React from "react";
import PropTypes from "prop-types";

class Modal extends React.Component
{
	constructor( props )
	{
		super( props );
		
		this.state = {
			visible: false
		};
		
		this.setHide = this.setHide.bind( this );
		this.toggleVisible = this.toggleVisible.bind( this );
		
	} // function constructor(...)
	
	setHide( a_event )
	{
		this.setState(
			{
				visible: false
			}
		);
		
		document.body.removeAttribute( "style" );
		
	} // function setHide(...)
	
	toggleVisible()
	{
		const { overflow = true, onIsVisible, onCancel } = { ...this.props };
		
		if ( typeof onIsVisible === "function" )
		{
			onIsVisible( this.state.visible );
		}
		
		this.setState(
			{
				visible: !this.state.visible
			}
		);
		
		if ( overflow )
		{
			if ( !this.state.visible )
			{
				document.body.setAttribute( "style", "overflow-y:hidden" );
			}
			else
			{
				document.body.removeAttribute( "style" );
			}
		}
		
		if ( typeof onCancel === "function" )
		{
			onCancel();
		}
		
	} // function toggleVisible()
	
	submitInlineForm( a_event, reValidate = false )
	{
		const submitResult = this.props.onSubmit( a_event, reValidate );
		
		// Prüfen ob die Form erfolgreich abgeschickt wurde und alle API-Ergebnisse vorliegen
		if ( typeof submitResult !== "undefined" && typeof submitResult.then === "function" && !reValidate )
		{
			submitResult.then(
				result =>
				{
					// Formprüfung fortsetzen
					if ( result !== false )
					{
						this.submitInlineForm( a_event, true );
					}
					else
					{
						a_event.preventDefault();
					}
				}
			);
		}
		else if ( submitResult )
		{
			this.setHide();
		}
		else
		{
			a_event.preventDefault();
		}
		
	} // function submitInlineForm()
	
	confirmForm( a_event, a_props )
	{
		if ( typeof a_props.onClick === "function" && a_props.onClick( a_event ) !== false )
		{
			this.setHide();
		}
		
	} // function confirmForm(...)
	
	handleKeyPress( a_event )
	{
		if ( ( a_event.key === "Esc" || a_event.key === "Escape" ) && this.state.visible )
		{
			this.setHide();
		}
		
	} // function handleKeyPress
	
	render()
	{
		const { trigger, children, title, footer, className, additionalModalHtml } = { ...this.props };
		const buttonClass = trigger && ( trigger.type.indexOf( "button" ) || trigger.type.indexOf( "a" ) ) ? " button" : "";
		const footerChildren = footer.type === "button" ? footer : footer.props.children;
		
		if ( this.state.visible )
		{
			return (
				<div className={className} onKeyUp={this.handleKeyPress.bind( this )}>
					<div className={"modal"}>
						{
							title &&
							<div className={"dialogHead"}>
								{
									typeof title === "object"
										? title
										: <h4>{title}</h4>
								}
							</div>
						}
						{
							children &&
							<div className={"dialogBody"}>
								{children}
							</div>
						}
						{additionalModalHtml && additionalModalHtml}
						<div className={"dialogFoot"}>
							{
								React.Children.map( footerChildren,
									button =>
									{
										switch ( button.props && button.props.hasOwnProperty( "data-modal" ) ? button.props[ "data-modal" ] : "default" )
										{
											case "submitForm":
												return <button {...button.props}
												               onClick={a_event => this.submitInlineForm( a_event )}>{button.props.children}</button>;
											case "confirm":
												return <button {...button.props}
												               onClick={a_event => this.confirmForm( a_event, button.props )}>{button.props.children}</button>;
											case "close":
												return <button {...button.props}
												               onClick={() => this.toggleVisible()}>{button.props.children}</button>;
											default:
												return button;
										}
									}
								)
							}
						</div>
					</div>
					<div className={"modalOverlay"} onClick={this.setHide}/>
					<div className={`inline${buttonClass}`} onClick={this.toggleVisible}>{trigger}</div>
				</div>
			);
		}
		else
		{
			return <div className={`inline${buttonClass}`} onClick={this.toggleVisible}>{trigger}</div>;
		}
		
	} // function render()
}

Modal.propTypes = {
	title: PropTypes.oneOfType( [ PropTypes.string, PropTypes.object ] ),
	trigger: PropTypes.object.isRequired,
	footer: PropTypes.oneOfType( [ PropTypes.array, PropTypes.object ] ).isRequired,
	additionalModalHtml: PropTypes.object,
	className: PropTypes.string,
	isValid: PropTypes.bool,
	checkForm: PropTypes.func,
	onSubmit: PropTypes.func,
	onCancel: PropTypes.func,
	onIsVisible: PropTypes.func
};

// Modal.defaultProps = {
// 	footer: ""
// };

export default Modal;